import { useEffect, useRef } from "react";
import isEqual from "lodash.isequal";

export const useDeepCompareEffect = (callback: () => void, dependencies: any[]) => {
    const prevDependencies = useRef<any[]>(dependencies);

    if (!isEqual(prevDependencies.current, dependencies)) {
        prevDependencies.current = dependencies;
    }

    useEffect(callback, [prevDependencies.current]);
}import { useEffect, useRef } from "react";
import isEqual from "lodash.isequal";

export const useDeepCompareEffect = (callback: () => void, dependencies: any[]) => {
    const prevDependencies = useRef<any[]>(dependencies);

    if (!isEqual(prevDependencies.current, dependencies)) {
        prevDependencies.current = dependencies;
    }

    useEffect(callback, [prevDependencies.current]);
}